import React, { useState, useRef, useEffect } from 'react';
import { RefinementList } from 'react-instantsearch-dom';

import Button from '3-components/Buttons/Button';
import CustomRefinementCount from './CustomRefinementCount';
// import useViewport from './useViewport';

interface CustomRefinementListProps {
    filterAttribute: string;
    label: string;
    defaultRefinement?: [string] | null;
}

const CustomRefinementList = ({ filterAttribute, label, defaultRefinement }: CustomRefinementListProps) => {
    const [showRefinement, setShowRefinement] = useState(false);

    const openCloseHandle = () => {
        setShowRefinement(!showRefinement);
    };

    const wrapperRef = useRef('customRefList');

    const clickOutside = (ref, onClickOutside) => {
        useEffect(() => {
            /**
             * Invoke Function onClick outside of element
             */
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    onClickOutside();
                }
            }
            // Bind
            document.addEventListener('mousedown', handleClickOutside);
            return () => {
            // dispose
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, [ref, onClickOutside]);
    };

    clickOutside(wrapperRef, () => {
        setShowRefinement(false);
    });

    return (
        <div ref={wrapperRef} className={`custom-refinement-list tablet-version${showRefinement ? ' expanded' : ''}`}>
            <Button
                btnText={<CustomRefinementCount labelAttribute={label} targetAttribute={filterAttribute} />}
                btnSkin="2"
                onclick={openCloseHandle}
                btnCustomClass="refinement-button"
                suffixIcon="chevron-down"
            />
            <div className="refinement-container">
                <RefinementList attribute={filterAttribute} facetOrdering={true} defaultRefinement={defaultRefinement} />
            </div>
        </div>
    );
};

export default CustomRefinementList;
